import { FC } from "react";
import { IconPropsType } from ".";

export const SmsHistory: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? "16"}
      height={props.size ?? "16"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1392 8.03014C17.1392 7.31642 17.7178 6.73783 18.4315 6.73783H26.1854C28.8023 6.73783 30.9238 8.85931 30.9238 11.4763V22.6763C30.9238 25.2933 28.8023 27.4148 26.1854 27.4148H10.6777C8.06069 27.4148 5.93921 25.2933 5.93921 22.6763V20.9532C5.93921 20.2395 6.5178 19.6609 7.23152 19.6609C7.94524 19.6609 8.52383 20.2395 8.52383 20.9532V22.6763C8.52383 23.8658 9.48814 24.8301 10.6777 24.8301H26.1854C27.3749 24.8301 28.3392 23.8658 28.3392 22.6763V11.4763C28.3392 11.3594 28.3299 11.2447 28.312 11.1329L20.2024 18.5052C19.1872 19.4281 17.6263 19.3909 16.6562 18.4209C16.1515 17.9162 16.1515 17.0979 16.6562 16.5933C17.1576 16.0918 17.9685 16.0886 18.4739 16.5835L26.4442 9.33784C26.3593 9.32767 26.273 9.32245 26.1854 9.32245H18.4315C17.7178 9.32245 17.1392 8.74386 17.1392 8.03014Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.81614 15.784C12.1952 15.784 14.1238 13.8554 14.1238 11.4763C14.1238 9.09722 12.1952 7.1686 9.81614 7.1686C7.43706 7.1686 5.50844 9.09722 5.50844 11.4763C5.50844 13.8554 7.43706 15.784 9.81614 15.784ZM9.81614 18.3686C13.6227 18.3686 16.7084 15.2828 16.7084 11.4763C16.7084 7.66978 13.6227 4.58398 9.81614 4.58398C6.00962 4.58398 2.92383 7.66978 2.92383 11.4763C2.92383 15.2828 6.00962 18.3686 9.81614 18.3686Z"
        fill={props.color ?? "#555555"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.81614 7.59937C10.5299 7.59937 11.1084 8.17795 11.1084 8.89168V11.4763C11.1084 11.819 10.9723 12.1477 10.7299 12.3901L9.00686 14.1132C8.50218 14.6178 7.68394 14.6178 7.17926 14.1132C6.67458 13.6085 6.67458 12.7902 7.17926 12.2856L8.52383 10.941V8.89168C8.52383 8.17795 9.10241 7.59937 9.81614 7.59937Z"
        fill={props.color ?? "#555555"}
      />
    </svg>
  );
};
